import { Button } from "@mui/material";
import * as React from "react";
import * as classnames from "classnames";

interface ButtonOkProps {
    clicked: (label: string) => void;
    label: string;
}

export function NumberButton(props: ButtonOkProps): React.ReactElement {
    const { clicked, label } = props;

    const onClick = (e: React.SyntheticEvent) => {
        // Ensure touchEnd isn't followed by onMouseUp
        e.preventDefault();
        clicked(label);
    };

    const className = classnames("tc-num-button2");

    return (
        <Button
            className={className} 
            onClick={onClick}
            variant="contained"
            color="primary"
        >
            {label}
        </Button>
    );
}
